import type { HTMLAttributes, ReactNode } from 'react';

type BadgeTone = 'gold' | 'crimson' | 'muted';

const toneClasses: Record<BadgeTone, string> = {
  gold: 'bg-[rgba(201,169,110,0.16)] text-[var(--la-gold)]',
  crimson: 'bg-[rgba(128,0,64,0.2)] text-[var(--la-lilith)]',
  muted: 'bg-white/5 text-[var(--la-text-muted)]',
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children?: ReactNode;
  tone?: BadgeTone;
}

export function Badge({ children, className = '', tone = 'muted', ...props }: BadgeProps) {
  return (
    <span
      className={`inline-flex rounded-full px-3 py-1 text-[0.72rem] uppercase tracking-[0.2em] ${toneClasses[tone]} ${className}`.trim()}
      {...props}
    >
      {children}
    </span>
  );
}
